///
/// EarthBrowser - Storage Manager Browser
///
/// Movable window for managing browser storage (VFS, IndexedDB, localStorage)
/// Created by Matt Giger on December 21, 2025
/// Copyright (c) 2025 Geodata Labs
///

import { memo, useCallback, useMemo } from 'react'
import { DatasetBrowserWindow } from '@/components/windows/DatasetBrowserWindow'
import { useRegisterWindowContent } from '@/components/windows/WindowContentRegistry'
import { StorageManager } from '@/components/features/dev-tools/storage-manager/StorageManager'
import type { DatasetBrowserWindowState } from '@/redux/dialogSlice'
import { HardDrive } from 'lucide-react'

interface StorageManagerBrowserRendererProps {
	windowState: DatasetBrowserWindowState
}

export const StorageManagerBrowserRenderer = memo(function StorageManagerBrowserRenderer({
	windowState,
}: StorageManagerBrowserRendererProps) {
	const content = useMemo(() => (
		<div className="h-full overflow-y-auto">
			<StorageManager />
		</div>
	), [])

	const contentRenderer = useCallback(() => content, [content])
	useRegisterWindowContent(windowState?.id, contentRenderer)

	return (
		<DatasetBrowserWindow
			windowState={windowState}
			icon={<HardDrive className="w-5 h-5" />}
			iconColor="text-purple-400"
		>
			{content}
		</DatasetBrowserWindow>
	)
})

